import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { UiButtonComponent } from '../../atoms/button/button.component';

/**
 * Molécula: sección de formulario con título, descripción opcional,
 * acción Agregar opcional a la derecha del header y cuerpo proyectado.
 *
 * Presentacional: no valida ni persiste. La feature proyecta campos.
 */
@Component({
  selector: 'ui-form-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiButtonComponent],
  templateUrl: './form-section.component.html',
  styleUrl: './form-section.component.scss',
  host: {
    class: 'ui-form-section-host',
    '[class.ui-form-section-host--block]': 'block()',
    '[class.ui-form-section-host--fill]': 'fill() || pinned()',
    '[class.ui-form-section-host--pinned]': 'pinned()',
    '[class.ui-form-section-host--flush]': 'flush()',
    '[class.ui-form-section-host--body-center]': 'bodyAlign() === "center"',
  },
})
export class UiFormSectionComponent {
  /** Título de la sección (requerido). */
  readonly title = input.required<string>();

  /**
   * Muestra el header (título, descripción y acciones).
   * Si es false, el título se usa como aria-label del panel.
   */
  readonly showHeader = input(true);

  /** Descripción opcional bajo el título. */
  readonly description = input('');

  /** Si es true, el host ocupa el 100% del ancho disponible. */
  readonly block = input(true);

  /**
   * Estira la sección al alto del padre. El cuerpo ocupa el resto y
   * hace scroll interno. Sustituye ::ng-deep sobre .ui-form-section.
   */
  readonly fill = input(false);

  /**
   * Ancla el panel al host (position: absolute). Pensado para la
   * columna de factura. Activa fill.
   */
  readonly pinned = input(false);

  /**
   * Barra al borde (totales): sin radio ni bordes laterales/inferiores,
   * sombra superior.
   */
  readonly flush = input(false);

  /**
   * Alinea el cuerpo al centro (gráficas). Incluye overflow-x auto.
   */
  readonly bodyAlign = input<'start' | 'center'>('start');

  /**
   * Muestra el botón Agregar del header (primary / sm).
   * Estilo fijo en la molécula para que todas las vistas lo hereden igual.
   */
  readonly showAddButton = input(false);

  /** Etiqueta del botón Agregar. */
  readonly addLabel = input('Agregar');

  /** Clic en el botón Agregar del header. */
  readonly addClick = output<void>();

  /**
   * El título del header es clicable (cursor, foco y teclado).
   * Apagado por defecto: no cambia las secciones existentes.
   */
  readonly titleClickable = input(false);

  /** Clic o activación por teclado del título. Solo emite si `titleClickable`. */
  readonly titleClick = output<void>();

  protected onTitleClick(): void {
    if (!this.titleClickable()) return;
    this.titleClick.emit();
  }

  protected onTitleKeydown(event: KeyboardEvent): void {
    if (!this.titleClickable()) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this.titleClick.emit();
  }
}
